import React from 'react';

const CandidateDetails = ({ selectedApp, talentAge, tp, handleViewCandidateProfile }) => {
    return (
        <div className="card-dark p-3 rounded" style={{background: '#131824', border: '1px solid #21293d'}}>
            <div className="row">
                {/* Left Column: Audition Script */}
                <div className="col-6">
                    <div className="text-primary mb-2" style={{fontSize: '0.9rem'}}>Audition Script</div>
                    <div className="text-muted mb-0 small" style={{fontSize: '0.75rem', lineHeight: '1.4', maxHeight: '120px', overflowY: 'auto'}} dangerouslySetInnerHTML={{ __html: selectedApp.c_roleScript }} />
                </div>
                
                {/* Right Column: Candidate Details */}
                <div className="col-6 border-start border-secondary ps-3">
                    <div className="text-primary mb-2" style={{fontSize: '0.9rem'}}>Candidate Details</div>
                    <ul className="list-unstyled mb-0" style={{fontSize: '0.8rem'}}>
                        <li className="mb-1">
                            <span className="text-muted d-inline-block" style={{width: '65px'}}>Name:</span> 
                            <span className="fw-bold text-white" style={{cursor: 'pointer', textDecoration: 'underline'}} onClick={handleViewCandidateProfile}>
                                {selectedApp.talent_name}
                            </span>
                        </li>
                        <li className="mb-1"><span className="text-muted d-inline-block" style={{width: '65px'}}>Age:</span> <span className="text-white">{talentAge} Yrs</span></li>
                        <li className="mb-1"><span className="text-muted d-inline-block" style={{width: '65px'}}>Gender:</span> <span className="text-white">{tp.gender || '---'}</span></li>
                        <li className="mb-1"><span className="text-muted d-inline-block" style={{width: '65px'}}>Height:</span> <span className="text-white">{tp.height || '---'} cm</span></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default CandidateDetails;